import React from 'react';
import cn from 'classnames';

import Section from 'react-scale/components/ui/section';
import SectionTitle from 'react-scale/components/ui/section-title';

import Task from './Task';
import Slack from './Slack';
import CostEffective from './CostEffective';

const EnterpriseReady = ({
  overtitle,
  title,
  subtitle,
  annotationList,
  task,
  slack,
  costEffective,
  bg
}) => (
  <Section bg={bg}>
    <SectionTitle overtitle={overtitle} title={title} subtitle={subtitle} />
    <ul className="grid gap-y-20 lg:gap-y-32">
      <Item title={task.title} text={task.text}>
        <Task annotationList={annotationList} />
      </Item>
      <Item title={slack.title} text={slack.text} reverse>
        <Slack />
      </Item>
      <Item title={costEffective.title} text={costEffective.text}>
        <CostEffective />
      </Item>
    </ul>
  </Section>
);

const Item = ({ title, text, reverse, children }) => (
  <li>
    <article className="grid items-center gap-4 md:grid-cols-2 lg:gap-16">
      <div className={reverse ? 'md:order-2' : 'md:order-1'}>
        <h3 className="mb-4 text-3xl text-white font-aeonik">{title}</h3>
        <p className="text-base md:text-lg lg:text-xl lg:leading-relaxed text-neutral-300">
          {text}
        </p>
      </div>
      <div className={cn('relative', reverse ? 'md:order-1' : 'md:order-2')}>{children}</div>
    </article>
  </li>
);

EnterpriseReady.defaultProps = {
  bg: 'bg-black',
  overtitle: 'Enterprise Ready',
  title: 'Custom Annual Plans and SLAs',
  subtitle: 'Get started today with on-demand, or chat with us about an enterprise plan.',

  task: {
    title: 'Guaranteed Task Completion Time',
    text: 'Enterprise-grade SLAs include task completion times and tasks can be rapidly scaled up and down to meet your requirements.'
  },
  slack: {
    title: '24/7 Development Support',
    text: 'Each enterprise customer is paired with a dedicated engagement manager who will ensure smooth on-boarding and continued data delivery.'
  },
  costEffective: {
    title: 'Cost Effective',
    text: 'Enterprise engagements provide upfront and volume-based discounts, and is the most cost-effective solution for high-quality labels. Plus with Scale AI, there are no platform fees.'
  },
  annotationList: [
    {
      icon: 'cuboid',
      name: 'Cuboid'
    },
    {
      icon: 'linesSplines',
      name: 'Lines & Splines'
    },
    {
      icon: 'point',
      name: 'Point'
    },
    {
      icon: 'polygon',
      name: 'Polygon'
    }
  ]
};

export default EnterpriseReady;
